import React, { useState } from 'react'

/**
 * Reusable FAQ accordion for service pages.
 * Reuses the existing global .faq-list / .faq-item / .faq-question /
 * .faq-answer classes already defined in Allergy.css so no new CSS
 * needs to be introduced.
 *
 * Props:
 *  - title: heading text shown above the accordion
 *  - faqs: [{ question, answer }]
 */
const ServiceFAQ = ({ title = 'Frequently Asked Questions', faqs = [] }) => {
  const [activeIndex, setActiveIndex] = useState(null)

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index)
  }

  if (!faqs.length) return null

  return (
    <div className='faq-list' style={{ margin: '30px 0' }}>
      <h3 style={{ fontSize: '23px' }}>{title}</h3>
      {faqs.map((item, index) => (
        <div key={index} className={`faq-item ${activeIndex === index ? 'active' : ''}`}>
          <div className='faq-question' onClick={() => toggleFAQ(index)}>
            <h3>{item.question}</h3>
            <span className='faq-icon'>{activeIndex === index ? '\u2212' : '+'}</span>
          </div>
          <div className='faq-answer-wrapper'>
            <div className='faq-answer'>
              <p>{item.answer}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default ServiceFAQ
